import React from 'react';
const rungs = [{
  symbol: '▲',
  name: 'DO',
  who: 'The resident does it',
  body: 'For the resident who still chats, chooses and follows steps.',
  band: 'bg-sage',
  badge: 'bg-sage text-white',
  offset: 'sm:mt-12'
}, {
  symbol: '■',
  name: 'HELP',
  who: 'The resident does it with help',
  body: 'Guided: one step at a time, modeled, with two choices.',
  band: 'bg-gold',
  badge: 'bg-gold text-gold-ink',
  offset: 'sm:mt-6'
}, {
  symbol: '●',
  name: 'FEEL',
  who: 'The resident receives it',
  body: 'Sound, texture, scent or gentle movement for the resident who responds mainly to touch and sound. It doubles as a 1:1 room visit.',
  band: 'bg-smoke',
  badge: 'bg-smoke text-white',
  offset: 'sm:mt-0'
}];
const coverage = [{
  label: 'Every activity',
  body: 'Two pages: Run, to lead it, and Ladder, the same activity at DO, HELP and FEEL for one session'
}, {
  label: 'Every session',
  body: 'The Three-Way Session formula in 15, 30 and 45 minutes, plus a 10-minute 1:1 visit'
}, {
  label: 'Materials',
  body: 'Runs with what your community already has: music, towels, photos, everyday objects. Minimal printing'
}, {
  label: 'Mixed rooms',
  body: 'A 3-question rung check places each resident for today’s activity, not as a fixed label'
}, {
  label: 'Stop & Tell',
  body: 'A box on every activity with the signs that pause it and go to nursing. Nothing is ever forced'
}, {
  label: 'Format',
  body: 'Landscape pages that read on a phone mid-session or print in black and white. Nothing to cut or laminate'
}];
const steps = ['Welcome · 3 min', 'Warm-Up · 5 min', 'Main activity, three rungs · 15 min', 'Wind-Down · 5 min', 'Note it · 2 min'];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-plum-mid" data-id="element-225" data-mp="2ck140xpczf33">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-226" data-mp="1rsvt06of8teb">
        <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-227" data-mp="1ruyupnyxsayv">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-bold text-white text-3xl sm:text-5xl" data-id="element-228" data-mp="21r1tqkyhrthl">
          The Do · Help · Feel Ladder
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/80" data-id="element-229" data-mp="1wq4f2icoxhku">
          Prep one activity. Run it three ways. Every activity in the pack is
          written as a{' '}
          <span className="font-semibold text-white" data-id="element-230" data-mp="1416xkhgazot5">Three-Way Activity</span>: the
          same session, with a rung for each resident in the room.
        </p>

        <ul className="mx-auto mt-9 grid max-w-3xl items-start gap-3 text-left sm:grid-cols-3" data-id="element-231" data-mp="1e0fwzptxtvmw">
          {rungs.map(r => <li key={r.name} className={`overflow-hidden rounded-2xl border border-plum-line bg-plum-card ${r.offset}`} data-id="element-232" data-mp="qa26w4uwy6uy">
              <span className={`block h-1.5 ${r.band}`} data-id="element-233" data-mp="2wz44wraawu96" />
              <div className="p-4" data-id="element-234" data-mp="2wycavkwcr4l0">
                <div className="flex items-center gap-2.5" data-id="element-235" data-mp="31r5axvgvloqr">
                  <span aria-hidden="true" className={`flex h-9 w-9 items-center justify-center rounded-full text-base font-bold ${r.badge}`} data-id="element-236" data-mp="31sor7m2j7zsj">
                    {r.symbol}
                  </span>
                  <span className="font-display text-2xl font-bold text-white" data-id="element-237" data-mp="3fry70kmtsrvz">
                    {r.name}
                  </span>
                </div>
                <p className="mt-3 text-[11px] font-semibold uppercase tracking-widest text-gold" data-id="element-238" data-mp="36q8hxlgf251d">
                  {r.who}
                </p>
                <p className="mt-1.5 text-sm text-white/85" data-id="element-239" data-mp="3apz57f6qi315">{r.body}</p>
              </div>
            </li>)}
        </ul>

        <p className="mt-10 text-[11px] font-semibold uppercase tracking-[1.8px] text-white/70" data-id="element-240" data-mp="1vd63avxvnpju">
          The Three-Way Session
        </p>
        <ol className="mx-auto mt-3 flex max-w-3xl flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-241" data-mp="2fjt4gq90r4vd">
          {steps.map((step, i) => <li key={step} className="flex items-center gap-2 sm:gap-3" data-id="element-242" data-mp="2aqq9qesi9pdl" data-mpi={i}>
              <span className="rounded-full bg-gold/15 px-4 py-2 text-[13px] font-semibold text-gold-hover" data-id="element-243" data-mp="25ui0fi0zoqec">
                <span className="mr-1.5 font-display italic" data-id="element-244" data-mp="20w84v6bcrns7">{i + 1}.</span>
                {step}
              </span>
              {i < steps.length - 1 && <span className="hidden h-px w-5 bg-gold/50 sm:block" data-id="element-245" data-mp="2tj17xvc7sz5d" />}
            </li>)}
        </ol>

        <ul className="mt-9 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-246" data-mp="2oiwt09qygch9">
          {coverage.map(item => <li key={item.label} className="rounded-xl border border-plum-line bg-white/5 px-4 py-3" data-id="element-247" data-mp="2kkp956172v1u">
              <span className="block text-[11px] font-semibold uppercase tracking-widest text-gold" data-id="element-248" data-mp="192xwxwum46xd">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white/90" data-id="element-249" data-mp="3ksnj8x6ugx24">
                {item.body}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}